var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6758 25C42.6758 34.7621 34.7621 42.6758 25 42.6758C15.2379 42.6758 7.32422 34.7621 7.32422 25C7.32422 15.2379 15.2379 7.32422 25 7.32422C34.7621 7.32422 42.6758 15.2379 42.6758 25ZM35.1983 19.3464C34.4313 18.5794 33.1878 18.5794 32.4208 19.3464L22.6996 29.0675L18.5334 24.9013C17.7664 24.1343 16.5229 24.1343 15.7559 24.9013C14.9889 25.6683 14.9889 26.9118 15.7559 27.6788L21.3109 33.2338C22.0778 34.0007 23.3214 34.0007 24.0883 33.2338L35.1983 22.1238C35.9652 21.3569 35.9652 20.1133 35.1983 19.3464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.b2753133c0047bbb8917b98f9f108d26.svg";
export { ForwardRef as ReactComponent };